
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 7.375a.625.625 0 110 1.25H2a.625.625 0 110-1.25h12z","fill":"#282E3E"}}),_c('path',{attrs:{"d":"M13.375 8a5.375 5.375 0 10-10.75 0 5.375 5.375 0 0010.75 0zm1.25 0a6.625 6.625 0 11-13.25 0 6.625 6.625 0 0113.25 0z","fill":"#282E3E"}}),_c('path',{attrs:{"d":"M8.39 14.488a.626.626 0 01-.78 0L8 14l.39.488zM9.876 8c0-1.863-.581-3.25-1.155-4.169A6.78 6.78 0 008 2.875a6.78 6.78 0 00-.72.956C6.706 4.75 6.125 6.137 6.125 8c0 1.863.581 3.25 1.155 4.169.259.414.517.731.72.955.203-.224.461-.541.72-.955C9.294 11.25 9.875 9.863 9.875 8zm1.25 0c0 2.137-.669 3.75-1.345 4.831-.337.54-.676.947-.933 1.222a5.848 5.848 0 01-.413.4l-.029.023-.01.007-.003.004H8.39A83.787 83.787 0 018 14l-.39.487h-.002l-.004-.004-.01-.007-.028-.024a5.848 5.848 0 01-.413-.4 7.965 7.965 0 01-.933-1.221C5.544 11.75 4.875 10.137 4.875 8c0-2.137.669-3.75 1.345-4.831.337-.54.676-.947.933-1.222a5.814 5.814 0 01.413-.4l.029-.023.01-.007.003-.004h.001l.097.12-.097-.121a.626.626 0 01.782 0L8 2l.39-.487h.002l.004.004.01.007.028.024.095.085c.08.072.189.177.318.314.257.275.596.683.933 1.222.676 1.081 1.345 2.694 1.345 4.831z","fill":"#282E3E"}})])
          )
        }
      }
    